import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import PersonAddOutlined from '@mui/icons-material/PersonAddOutlined';
import { useCvLanguage } from '../cvLanguage';

export default function CvPeopleView({ persons, onOpen, onCreate, disabled }) {
  const { t } = useCvLanguage();
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const create = async event => {
    event.preventDefault();
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      if (await onCreate(name.trim())) { setCreating(false); setName(''); }
    } finally { setBusy(false); }
  };
  return <>
    <Box className="cv-profiles-toolbar">
      <Typography color="text.secondary">{t('Cada persona tiene su propio espacio y sus propias versiones.')}</Typography>
      <Button variant="outlined" startIcon={<PersonAddOutlined />} disabled={disabled || busy} onClick={() => setCreating(true)}>{t('Añadir persona')}</Button>
    </Box>
    <Box className="cv-profiles-grid">{persons.map(person => <Box component="article" className="cv-profile-card" key={person.id}>
      <Typography component="h2">{person.name}</Typography>
      {persons.filter(p => p.name === person.name).length > 1 && <Typography variant="caption">{person.id.slice(-8)}</Typography>}
      <Typography color="text.secondary">{t('Currículums separados de tu perfil personal.')}</Typography>
      <Box className="cv-profile-actions"><Button onClick={() => onOpen(person.id)} disabled={disabled || busy} aria-label={t('Abrir currículums de {name}', {name: person.name})}>{t('Ver currículums')}</Button></Box>
    </Box>)}</Box>
    {!persons.length && !disabled && <Box className="cv-empty-profiles"><Typography component="h2">{t('Ayuda a alguien a dar su próximo paso.')}</Typography><Typography color="text.secondary">{t('Añade una persona para crear su primer currículum desde cero.')}</Typography></Box>}
    <Dialog open={creating} onClose={() => { if (!busy) setCreating(false); }} fullWidth maxWidth="xs" className="cv-profile-dialog">
      <Box component="form" onSubmit={create}>
        <DialogTitle>{t('Añadir persona')}</DialogTitle>
        <DialogContent><Typography color="text.secondary" sx={{mb: 2}}>{t('Crearemos un currículum vacío en su propio espacio.')}</Typography><TextField label={t('Nombre de la persona')} value={name} onChange={event => setName(event.target.value)} autoFocus required fullWidth disabled={busy} inputProps={{maxLength: 200}} /></DialogContent>
        <DialogActions><Button onClick={() => setCreating(false)} disabled={busy}>{t('Cancelar')}</Button><Button type="submit" variant="contained" disabled={busy || !name.trim()}>{t(busy ? 'Creando…' : 'Crear espacio')}</Button></DialogActions>
      </Box>
    </Dialog>
  </>;
}
